module.exports = __webpack_public_path__ + "img/philosophy3.b7da80ee.jpg";